import * as React from "react";
import * as _ from "lodash";
import {IRangeBucket} from "../models/metrics/IMetric";

export interface MetricLegendContainerProps {
    rangeBuckets: IRangeBucket[];
}

const MetricLegendContainer: React.StatelessComponent<MetricLegendContainerProps> = (props) => {
    return (
        <div className={"metric-legend-container"}>
            {
                _.map(props.rangeBuckets, (rangeBucket: IRangeBucket, index: number) => {
                    let color = !_.isEmpty(rangeBucket.meta) ? rangeBucket.meta.primaryColor : null;
                    return <div className={"range-item-container"} key={`${rangeBucket.label}-${index}`}>
                        {
                            !_.isNull(color) &&
                            <span className={"range-color"} style={{background: color}}></span>
                        }
                        <span>{rangeBucket.label}</span>
                        <span className={"metric-range"}>( {rangeBucket.rangeMin} - {rangeBucket.rangeMax} )</span>
                    </div>
                })
            }
        </div>
    )
}

export default MetricLegendContainer;